s<template>
  <div class="master-container">
    <v-content>
      <v-card flat class="mx-3 mt-2 pa-2">
        <v-card-title>ユーザー新規登録</v-card-title>
        <v-list-item-subtitle><strong class="red--text text--lighten-1">*</strong>：必須項目</v-list-item-subtitle>
        <v-form
          ref="form"
          v-model="valid"
          lazy-validation
        >
          <v-text-field
            v-model="formData.user_cd"
            :rules="cdRules"
            required
            placeholder='半角英数字、!@$#_.のみ使用可'
          >
            <template v-slot:label>
              ユーザーID<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.user_nm"
            :rules="mainRules"
            required
          >
            <template v-slot:label>
              氏名<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.user_knm"
            :rules="kanaRules"
            label="氏名カナ*"
            required
          >
            <template v-slot:label>
              氏名カナ<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.user_pwd"
            :rules="pwdRules"
            type='password'
            required
            placeholder='半角英数字、#$+-./:=?@[]^_`|のみ使用可'
          >
            <template v-slot:label>
              パスワード<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.user_pwd2"
            type='password'
            :rules="pwd2Rules"
            required
          >
            <template v-slot:label>
              パスワード再入力<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-text-field>
          <v-text-field
            v-model="formData.mladdrs_desc"
            :rules="emailRules"
            label="メールアドレス"
          >
          </v-text-field>
          <v-select
            v-model="formData.kngn_cd"
            :items="smallerAuthority"
            :rules="mustRules"
            label="権限*"
            item-text="kbn_nm"
            required
            return-object
          >
            <template v-slot:label>
              権限<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-select>
          <v-select
            multiple
            :rules="mustKiykRules"
            v-model="kiykSelectList"
            :items="visibleKiyk"
            label="監視対象"
            item-value="kiyk_cd"
            item-text="kiyk_nm"
            required
            return-object
          >
            <template v-slot:label>
              監視対象<strong class="red--text text--lighten-1">*</strong>
            </template>
          </v-select>
          <v-btn width="120" color="indigo lighten-5" depressed to='/UsrMstr/UsrMstrKnr'>キャンセル</v-btn>
          <div class="float-right">
            <!-- 保存された情報をダイアログに表示 -->
            <v-dialog v-model="checkDialog" width="500">
              <template v-slot:activator="{ on, attrs }">
                <v-btn dark color="indigo" width="120" v-bind="attrs" v-on="on" @click="validate">
                  登録
                </v-btn>
              </template>
              <v-card v-if="errorFlg">
                <v-card-title class="headline indigo lighten-4" primary-title>新規登録確認</v-card-title>
                <v-container v-if='loading'>
                  <v-row justify="center" align-content="center">
                    <v-col cols="6">
                      <v-progress-linear
                        color="indigo"
                        indeterminate
                        rounded
                        height="6"
                      ></v-progress-linear>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-text v-else>
                  <v-container>
                    <span style="white-space:pre-wrap;">{{errorMsg}}</span>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" text @click="closePopup()">OK</v-btn>
                </v-card-actions>
              </v-card>
              <v-card v-else>
                <v-card-title class="headline indigo lighten-4" primary-title>新規登録確認</v-card-title>
                <v-container v-if='loading'>
                  <v-row justify="center" align-content="center">
                    <v-col cols="6">
                      <v-progress-linear
                        color="indigo"
                        indeterminate
                        rounded
                        height="6"
                      ></v-progress-linear>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-text v-else>
                  <v-container>
                    <v-row>
                      以下の内容で登録します。よろしいですか？<br>
                    </v-row>
                    <v-row>
                      <span v-if="attentionFlg">
                        <strong class="red--text text--darken-3">
                          {{attentionMsg}}
                        </strong>
                      </span>
                    </v-row>
                    <!-- 登録内容 -->
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">ユーザーID</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.user_cd}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">氏名</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.user_nm}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">氏名カナ</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.user_knm}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">パスワード</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{pwdStr}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">メールアドレス</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.mladdrs_desc}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">権限</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{formData.kngn_cd.kbn_nm}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <span class="indigo--text text--darken-3">監視対象</span>
                      </v-col>
                      <v-col cols="12" sm="6">
                        {{kns}}
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" text @click="closePopup()">キャンセル</v-btn>
                  <v-btn dark color="indigo" width="120" @click="submit()" :disabled="attentionFlg">登録</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
        </v-form>
      </v-card>
    </v-content>
  </div>
</template>

<script>
import MstrHedr from '../../modules/MstrHedr'
import MsgList from '../../modules/MsgList'
import myAxios from '../../../axios/myAxios'

export default {
  components: {
    MstrHedr
  },
  props: {
    formData: Object
  },
  data () {
    return {
      mustRules: [
        v => !!v || '入力は必須です'
      ],
      mustKiykRules: [
        v => !!v || '入力は必須です',
        v => v.length > 0 || '入力は必須です'
      ],
      cdRules: [
        v => !!v || '入力は必須です',
        v => (v || '').indexOf(' ') < 0 || '空欄が含まれています',
        v => (v || '').indexOf('　') < 0 || '空欄が含まれています',
        v => (v || '').match(/^[A-Za-z0-9!@$#_.]*$/) || '半角英数字および!@#$_.で入力してください',
        v => v.length >= 6 || '6文字以上50文字以内で入力してください',
        v => v.length <= 50 || '6文字以上50文字以内で入力してください'
      ],
      mainRules: [
        v => !!v || '入力は必須です',
        v => (v || '').search(' ') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v || '').search('　') !== 0 || '最初に空欄を入れることは禁止です',
        v => v.length <= 100 || '100文字以内で入力してください'
      ],
      kanaRules: [
        v => !!v || '入力は必須です',
        v => (v || '').search(' ') !== 0 || '最初に空欄を入れることは禁止です',
        v => (v || '').search('　') !== 0 || '最初に空欄を入れることは禁止です',
        v => v.length <= 100 || '100文字以内で入力してください',
        v => (v || '').match(/^[ァ-ヶ ー]*$/) || 'カナで入力してください'
      ],
      pwdRules: [
        v => !!v || '入力は必須です',
        v => (v || '').indexOf(' ') < 0 || '空欄が含まれています',
        v => (v || '').match(/^[A-Za-z0-9#$+-./:=?@[\]^_`|]*$/) || '半角英数字および#$+-./:=?@[]^_`|で入力してください',
        v => v.length <= 30 || '8文字以上30文字以内で入力してください',
        v => v.length >= 8 || '8文字以上30文字以内で入力してください',
        v => (v || '').match(/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[#$+-./:=?@[\]^_`|])([A-Za-z0-9#$+-./:=?@[\]^_`|]{8,30})$/) || '半角英大文字、小文字、数字、使用可能な記号( #$+-./:=?@[]^_`| )からそれぞれ1文字以上使用する必要があります'
      ],
      pwd2Rules: [
        v => !!v || '入力は必須です',
        v => (!!v && v) === this.formData.user_pwd || 'パスワードと一致しません'
      ],
      Rules100: [
        v => (v == null || v.length <= 100) || '100文字以内で入力してください'
      ],
      emailRules: [
        v => (v === '' || /.+@.+\..+/.test(v)) || 'メールアドレスの形式で入力してください'
      ],
      loading: true,
      valid: true,
      checkDialog: false,
      userInfo: false,
      attentionFlg: false,
      userCdIsValid: false,
      userNameIsValid: true,
      userKanaNameIsValid: true,
      userPwdIsValid: true,
      userPwd2IsValid: true,
      mladdrsIsValid: true,
      kngnIsValid: true,
      userDupCdIsValid: true,
      kiykIsValid: true,
      blankIsValid: true,
      checkUserCd: 1,
      isChange: false,
      kngnList: [],
      kiykList: [],
      kiykSelectedList: [],
      kiykSelectList: '',
      kiykListLen: 0,
      pwdErrMsg: '',
      pwd2ErrMsg: MsgList.MSG_COM_0001,
      errorFlg: false,
      errorMsg: '',
      errorCdMsg: '',
      attentionMsg: '',
      errorMissMsg: '入力内容に間違いがあります。',
      user: {
        kngn_typ: null,
        kiyk_cd: null,
        user_cd: '',
        name: '',
        email_addr: ''
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isChange) {
      const dialog = window.confirm(MsgList.MSG_CREATE_FORM_LEAVE)
      if (dialog) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },
  created () {
    // ログインセッションを確認する
    myAxios.get('/api/common/session_manager', {type: 'isLogin'}).then(res => {
      const status = res.data.status
      const result = res.data.result
      myAxios.get('/api/common/session_manager', {type: 'kngn_check', url: this.$route.path}).then(res => {
        const kngnStatus = res.data.result.status
        // ログインセッションを確認できなければログイン画面に遷移する
        if (!(status && result && kngnStatus)) {
          alert(MsgList.MSG_SES_CANNOT_CONFIRM)
          this.$router.push('/')
          this.$store.dispatch('appSetting/fLogin')
        } else {
          this.$store.dispatch('appSetting/tLogin')
          // 入力フォームに表示するセレクトボックスの選択肢を取得
          myAxios.get('api/usr_mstr/user_master_shinki_touroku').then(res => {
            this.kngnList = res.data.kyotsu_list
            this.kiykList = res.data.keiyaku_list
            this.kiykListLen = this.kiykList.length
          })
          // ログインユーザの権限区分と契約コードを取得する
          myAxios.get('api/common/session_manager', {type: 'userinfo_kngn_kiyk'}).then(res => {
            this.user.kngn_typ = res.data.kngn_typ
            this.user.kiyk_cd = res.data.kiyk_cd
          })
        }
        // ユーザinfoポップアップ用の情報を取得
        myAxios.get('/api/common/session_manager', {type: 'userinfo_popup'}).then(res => {
          const status = res.data.status
          const result = res.data.result

          if (status && result) {
            this.user.name = res.data.name
            this.user.email_addr = res.data.email_addr
            this.user.user_cd = res.data.user_cd
          }
        })
      })
    })
  },
  methods: {
    validate () {
      this.loading = true
      this.checkForm()
    },
    closePopup () {
      this.checkDialog = false
      this.loading = true
    },
    // UserID入力チェック
    checkCd () {
      // ブランクチェック
      if (!this.formData.user_cd) {
        this.userCdIsValid = false
        this.blankIsValid = false
      // 空文字チェック
      } else if (this.formData.user_cd.indexOf(' ') > 0) {
        this.userCdIsValid = false
      } else if (this.formData.user_cd.indexOf('　') > 0) {
        this.userCdIsValid = false
      // 文字数
      } else if (this.formData.user_cd.length < 6 || this.formData.user_cd.length > 50) {
        this.userCdIsValid = false
      // 記号を含むかチェック
      } else if (!(this.formData.user_cd).match(/^[A-Za-z0-9!@$#_.]*$/)) {
        this.userCdIsValid = false
      } else if (!(this.userDupCdIsValid)) {
        this.userCdIsValid = false
        this.errorCdMsg = '既に使われているユーザーIDです。別のユーザーIDを入力してください。'
      } else {
        this.userCdIsValid = true
        this.errorCdMsg = ''
      }
    },
    // 氏名入力チェック
    checkName () {
      // ブランクチェック
      if (!this.formData.user_nm) {
        this.userNameIsValid = false
        this.blankIsValid = false
      // 空文字チェック
      } else if (this.formData.user_nm.search('　') === 0) {
        this.userNameIsValid = false
      } else if (this.formData.user_nm.search(' ') === 0) {
        this.userNameIsValid = false
      // 文字数チェック
      } else if (this.formData.user_nm.length > 100) {
        this.userNameIsValid = false
      } else {
        this.userNameIsValid = true
      }
    },
    // 氏名カナ入力チェック
    checkKanaName () {
      // ブランクチェック
      if (!this.formData.user_knm) {
        this.userKanaNameIsValid = false
        this.blankIsValid = false
      // 空文字チェック
      } else if (this.formData.user_knm.search('　') === 0) {
        this.userKanaNameIsValid = false
      } else if (this.formData.user_knm.search(' ') === 0) {
        this.userKanaNameIsValid = false
      // カナを含むかチェック
      } else if (!(this.formData.user_knm).match(/^[ァ-ヶ ー]*$/)) {
        this.userKanaNameIsValid = false
      // 文字数チェック
      } else if (this.formData.user_knm.length > 100) {
        this.userKanaNameIsValid = false
      } else {
        this.userKanaNameIsValid = true
      }
    },
    // メールアドレス入力チェック
    checkEmailAddr () {
      if (!this.formData.mladdrs_desc) {
        this.mladdrsIsValid = true
      } else if (!/.+@.+\..+/.test(this.formData.mladdrs_desc)) {
        this.mladdrsIsValid = false
      } else {
        this.mladdrsIsValid = true
      }
    },
    // 権限区分入力チェック
    checkKngn () {
      this.kngnIsValid = Boolean(this.formData.kngn_cd.kbn_typ)
    },
    // Passwordの入力チェック
    checkPwd () {
      // 入力値がブランクかどうか
      if (!this.formData.user_pwd) {
        this.userPwdIsValid = false
        this.blankIsValid = false
      // 8文字以上30文字以内かどうか
      } else if (this.formData.user_pwd.length < 8 || this.formData.user_pwd.length > 30) {
        this.userPwdIsValid = false
      // 半角英数字および#$+-./:=?@[]^_`|以外の文字列かどうか
      } else if (!this.formData.user_pwd.match(/^[A-Za-z0-9#$+-./:=?@[\]^_`|]*$/)) {
        this.userPwdIsValid = false
      // 半角英数字および#$+-./:=?@[]^_`|がそれぞれ1文字以上入力されていないかどうか
      } else if (!this.formData.user_pwd.match(/^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[#$+-./:=?@[\]^_`|])([A-Za-z0-9#$+-./:=?@[\]^_`|]{8,30})$/)) {
        this.userPwdIsValid = false
      // 空欄を含むかどうか
      } else if (this.formData.user_pwd.indexOf(' ') > 0) {
        this.userPwdIsValid = false
      // 再入力パスワードと一致するか
      } else if (this.formData.user_pwd !== this.formData.user_pwd2) {
        this.userPwdIsValid = false
      } else {
        this.userPwdIsValid = true
        this.pwdErrMsg = ''
      }
    },
    // Password再入力の入力チェック
    checkPwd2 () {
      // PasswordとPassword再入力が一致しているかどうか
      if (this.formData.user_pwd !== this.formData.user_pwd2) {
        this.userPwd2IsValid = false
      } else {
        this.userPwd2IsValid = true
      }
    },
    // 契約先
    checkKiyk () {
      // ブランクチェック
      if (this.kiykSelectList.length <= 0) {
        this.kiykIsValid = false
        this.blankIsValid = false
      // 全て範囲内ならtrue
      } else {
        this.kiykIsValid = true
      }
    },
    // 権限がシステム管理者(3),一般ユーザ(4)の時、契約先が複数選択されているときは注意文を生成する
    checkOneKiyk () {
      var kbnNum = Number(this.formData.kngn_cd.kbn_typ)
      if (kbnNum === 3 || kbnNum === 4) {
        if (this.kiykSelectList.length > 1) {
          this.attentionMsg = this.formData.kngn_cd.kbn_nm + ' は監視対象を複数選択できません'
          this.attentionFlg = true
        } else {
          this.attentionFlg = false
        }
      } else {
        this.attentionFlg = false
      }
    },
    insertKiyk () {
      // 契約先の名前を取得する
      var i = 0
      while (i < this.kiykListLen) {
        if (this.kiykList[i].kiyk_cd === this.user.kiyk_cd) {
          this.formData.kiyk_cd = this.kiykList[i]
        }
        i++
      }
    },
    // kiyk_cdの中身をオブジェクトからkiyk_cdのみのリストに変換する
    changeKiykList () {
      this.kiykSelectedList = []
      for (let i = 0; i < this.kiykSelectList.length; i++) {
        this.kiykSelectedList.push(this.kiykSelectList[i]['kiyk_cd'])
      }
      this.formData.kiyk_cd = this.kiykSelectedList
    },
    // エラーメッセージを作成する
    makeErrorMsg () {
      this.errorMsg = ''
      // blankエラー
      if (!this.blankIsValid) {
        this.errorMsg = MsgList.MSG_FORM_INVALID
      // ユーザIDエラー
      } else if (!this.userCdIsValid) {
        this.errorMsg = this.errorMsg + '\n' + this.errorCdMsg
      } else {
        // 入力間違いエラー
        this.errorMsg = this.errorMsg + '\n' + this.errorMissMsg
      }
      this.blankIsValid = true
      this.errorCdMsg = ''
    },
    // 確認画面遷移前チェックを行う
    checkForm () {
      // 各フォームを再チェック
      const checkAll = async () => {
        let res = await myAxios.get('api/usr_mstr/user_master_shinki_cd', {user_cd: this.formData.user_cd})
        this.userDupCdIsValid = res.data
        this.checkCd()
        this.checkName()
        this.checkKanaName()
        this.checkPwd()
        this.checkPwd2()
        this.checkEmailAddr()
        this.checkKngn()
        this.checkKiyk()
        this.checkOneKiyk()
        this.$refs.form.validate()
        // チェック項目が全て true ならば確認画面に遷移する false があればアラートを表示する
        if (this.userDupCdIsValid && this.userCdIsValid && this.userNameIsValid && this.userKanaNameIsValid && this.userPwdIsValid && this.mladdrsIsValid && this.kngnIsValid && this.kiykIsValid && this.blankIsValid) {
          this.isChange = false
          this.errorFlg = false
        } else {
          this.errorFlg = true
          this.makeErrorMsg()
        }
        this.loading = false
      }
      checkAll()
    },
    // 入力データをサーバーに送信・登録処理を行う
    submit () {
      this.changeKiykList()
      if (this.userCdIsValid) {
        this.checkDialog = false
        myAxios.post('/api/usr_mstr/user_master_shinki_touroku_kakunin', this.formData).then(res => {
          const status = res.data.status
          const result = res.data.result

          if (status && result) {
            this.$router.push('/UsrMstr/UsrMstrKnr')
          } else {
            alert(MsgList.MSG_FORM_SUBMIT_ERROR)
          }
        // eslint-disable-next-line handle-callback-err
        }).catch(err => {
          alert(MsgList.MSG_FORM_SUBMIT_ERROR)
        })
      }
    }
  },
  computed: {
    // 権限区分の選択肢を、ログインユーザ以下に絞る
    smallerAuthority: function () {
      return this.kngnList.filter(el => {
        return el.kbn_typ >= this.user.kngn_typ
      })
    },
    // 監視対象の選択肢を、権限区分に応じて切り替える
    visibleKiyk: function () {
      // eslint-disable-next-line eqeqeq
      if (this.user.kngn_typ == 1) {
        return this.kiykList
      } else {
        return this.kiykList.filter(el => {
          return el.kiyk_cd === this.user.kiyk_cd
        })
      }
    },
    // 監視対象名を取得
    kns: function () {
      let kanshiTaisho = ''
      for (let cnt = 0; cnt < this.kiykSelectList.length; cnt++) {
        if (kanshiTaisho === '') {
          kanshiTaisho += this.kiykSelectList[cnt].kiyk_nm
        } else {
          kanshiTaisho += ', ' + this.kiykSelectList[cnt].kiyk_nm
        }
      }
      return kanshiTaisho
    },
    // 確認画面に、入力したパスワード文字数だけ * を表示する
    pwdStr: function () {
      let pwdMaskStr = ''
      for (let cnt = 0; cnt < this.formData.user_pwd.length; cnt++) {
        pwdMaskStr += '*'
      }
      return pwdMaskStr
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/UsrMstr/UsrMstrSnkTurk.vue